<template>
  <div>
    <related-position-adder :payload="payload" :filter_related_resources="related_resources" :pick_and_close="false" @input="refresh"></related-position-adder>
    <div v-if="is_loading" class="is-flex is-justify-content-center" style="margin-top: 20px;">
      <div class="loading"></div>
    </div>
    <div v-else>
      <related-resource @deleted="getRelatedResources" v-for="related_resource in related_resources" :key="related_resource.id" :related_resource="related_resource" :show_divider="true">
      </related-resource>
    </div>
  </div>
</template>
<script>
import RelatedPositionAdder from '@/components/RelatedPositionAdder'
import RelatedResource from '@/components/RelatedResource'
export default {
  name: 'position-related-offers',
  props: ['payload'],
  data () {
    return {
      is_loading: true,
      related_resources: []
    }
  },
  created () {
    this.getRelatedResources()
  },
  methods: {
    getRelatedResources () {
      this.related_resources = []
      this.is_loading = true
      this.$network_utils.getRelatedResources({
        follower_type: 'Position',
        follower_id: this.payload.position_id,
        approval_statuses: 'true,NULL'
      }).then(response => {
        this.is_loading = false
        this.related_resources = response
      })
    },
    refresh () {
      this.getRelatedResources()
    }
  },
  components: {
    RelatedPositionAdder,
    RelatedResource
  }
}
</script>
